export const getTranslationsFromStorage = (): string | null => {
  const translationsData: string | null = localStorage.getItem('translations');

  return translationsData ? JSON.parse(translationsData) : null;
};
